import React, { useState } from "react";

import { useLocation } from "react-router-dom";

import { BlockStandard } from "components/admin/BlockStandard";
import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { FileUpload } from "components/MUIExtensions/FileUpload";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { sendInvoiceFile } from "api/onboarding";
import { useToken } from "contexts/UserContext";
import { useSetError } from "contexts/ErrorContext";

export const ConsumerBillUpload = ({ history }) => {
  const token = useToken();
  const [file, setFile] = useState<HTMLInputElement["files"]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { energyGroup, building, setBuilding } = useGreenEnergyContext();
  const location = useLocation();
  const setGlobalError = useSetError();

  const cameFromBuildingHasFV =
    (location.state as any)?.from === "/onboarding/building-has-fv";

  const FRAME_DATA = {
    title: cameFromBuildingHasFV
      ? "Cadastro de imóveis"
      : "Contrato de energia verde",
    buttonText: "Continuar",
    imgSrc: "/static/img/solutions/billing.png",
    skipTo: cameFromBuildingHasFV ? "/onboarding/energy-cost" : "/solutions/",
    h2Subtitle: "Insira sua fatura de energia",
    explanationBody:
      "A fatura é fundamental para registrarmos a quantidade de energia que você precisa",
  };

  const handleUploadedFile = (files) => {
    setFile(files);
  };

  const handleSubmit = async () => {
    if (cameFromBuildingHasFV) {
      setBuilding((prevState) => ({ ...prevState, invoice: file }));
      history.push("/onboarding/energy-cost");
    } else if (building.name) {
      setBuilding((prevState) => ({ ...prevState, invoice: file }));
      history.push("energy-cost");
    } else {
      // user is in one of the shorter flows and will send the invoice asap
      try {
        setIsLoading(true);
        await sendInvoiceFile(token, file);
        history.push(
          energyGroup === "groupB"
            ? "/solutions/green-energy-unavailable"
            : "/solutions/green-energy-callback"
        );
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
        setIsLoading(false);
      }
    }
  };

  return (
    <SolutionsFrame
      {...FRAME_DATA}
      isDisabled={!file}
      onButtonClick={handleSubmit}
      isLoading={isLoading}
    >
      <BlockStandard hideDivider>
        <FileUpload
          fileName={file ? file[0].name : ""}
          text="Enviar a fatura de energia mais recente"
          onFileUpload={handleUploadedFile}
        />
      </BlockStandard>
    </SolutionsFrame>
  );
};
